import com from '../../../../../comMapping.js';
export function getdata() {

	let obj = {
		headData: [{
			title: '数电票号码',
			prop: 'faphm',
			width: '150',
			issort: true,
			custom: true,
		}, {
			title: '单据号',
			prop: 'danjh',
			width: '150',
			issort: true,
		}, {
			title: '单据状态',
			prop: 'fapzt',
			width: '100',
			custom: true,
			showFilter: true,
			checkList: ['7', '4'],
			dataList: [{
				name: "开票失败",
				code: "7"
			}, {
				name: "已开票",
				code: "4"
			}, ]
		}, {
			title: '发票类型',
			prop: 'faplxdm',
			width: '100',
			custom: true,
			showFilter: true,
			checkList: com.fplx.map(v => v.value),
			dataList: com.fplx.map(v => {
				return {
					name: v.label,
					code: v.value
				}
			}),
		}, {
			title: '开票时间',
			prop: 'kaiprq',
			width: '200',
			issort: true,
			custom: true,
		}, {
			title: '价税合计',
			prop: 'jiashj',
			width: '100',
			issort: true,
			AmountFormat: true,
			custom: true,
		}, {
			title: '购方名称',
			prop: 'goufmc',
			width: '100',
			issort: true,
		}, {
			title: '任务批次号',
			prop: 'taskBatchNo',
			width: '200',
			issort: true,
		}, {
			title: '最近执行时间',
			prop: 'startDate',
			width: '200',
			issort: true,
		}, {
			title: '任务完成时间',
			prop: 'endDate',
			width: '200',
			issort: true,
		}, {
			title: '处理状态',
			prop: 'naturalUpload',
			width: '100',
			showFilter: true,
			custom: true,
			checkList: ['-1', '0', '1', '2'],
			dataList: [{
					name: "处理失败",
					code: "-1"
				},
				{
					name: "未处理",
					code: "0"
				}, {
					name: "处理中",
					code: "1"
				}, {
					name: "处理成功",
					code: "2"
				},
			]
		}, {
			title: '错误原因',
			prop: 'errorMessage',
			width: '100',
			issort: true,
		}],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
